import type { FetchOrganizationsArgs } from '../../api/types/organizations.types';

import { queryKeys } from '../../queryKeys';
import { useInfiniteQuery } from '../base';

export default function useInfiniteSwitcherOrganizations(
  filters: FetchOrganizationsArgs['filters'],
  enabled = true,
  /**
   * WHICH ACCOUNT the cached list belongs to (PR-2.1). `/auth/me/organizations` is a
   * self-scoped route — its answer is a property of the caller, not of the filters — but
   * nothing in the key said so, so an identity that changed without a remount (a login in
   * the same route branch, a super admin's tenant move) read the previous account's rows
   * straight out of the cache and seeded the switcher from them. Appended to the key
   * rather than folded into `filters`, which is the request.
   */
  scopeKey?: string,
) {
  const { queryFn, queryKey } =
    queryKeys.organizations.fetchInfiniteSwitcherOrganizations({ filters });
  const scopedQueryKey =
    scopeKey === undefined ? queryKey : [...queryKey, scopeKey];
  return useInfiniteQuery({
    enabled,
    initialPageParam: '1',
    meta: {
      limit: filters?.limit ?? '25',
    },
    queryFn: async (context: any) => {
      const rep = await queryFn({ ...context, queryKey: scopedQueryKey });
      return rep;
    },
    queryKey: scopedQueryKey,
  });
}
